
export const OrderRequestTemplate = `
    <div>
        <div>{{accountNumber}}</div>
        <div>{{side | tfSide | translate}} {{quantity | number : 0}} {{code}} @ {{limit}}</div>
    </div>
`;

export const SingleOrderFormatTemplate = `
    <div>
        ${OrderRequestTemplate}
        <div ng-if="isOption">
            {{strike}} {{expiry | date : 'dd MMM yy'}} {{type | tfOptionType}} ({{style | tfOptionStyleShort}})
        </div>
    </div>
`;

/* Growl is really bad for targeting with CSS, hence the inline styles on the span */
export const TmcOrderFormatTemplate = `
    <div>
        <div>{{accountNumber}}</div>
        <div>{{code}}</div>
        <div>{{quantity | number : 0}} {{underlying}} @ {{limit}}</div>
        <ul>
            <li ng-repeat="leg in legs">
                {{leg.side | tfSideShort | translate}}
                {{leg.ratio}}
                {{leg.code}}
                <span ng-if="leg.isOption" style="display: inline-block; font-size: inherit">
                    {{leg.strike}}
                    {{leg.expiry | date : 'dd MMM yy'}}
                    {{leg.type | tfOptionType}} ({{leg.style | tfOptionStyleShort}})
                </span>
            </li>
        </ul>
    </div>
`;
